import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Injectable({
  providedIn: 'root'
})
export class ProductServiceService {

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
  ) { }

  openDialog(componentName: any, height: any, width: any, maxWidth: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth: maxWidth,
      data: dataModel,
      disableClose: true,
      position: { right: '0px', top: '0px' },
    });
  }

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 1500 });
  }

  openDeleteDialog(componentName: any, height: any, width: any, dataModel: any, maxwidth: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: maxwidth,
    });
  }

  openSocialBrand(componentName: any, height: any, width: any, data: any, maxWidth: string = '100vw', maxHeight: string = '100vh') {
    return this.dialog.open(componentName, {
      height: height,
      width: width,
      data: data,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    });
  }

  openBottomSheet(componentName: any, data: any) {
    return this._bottomSheet.open(componentName, {
      data: data,
    });
  }

  getProductList(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/ecommerce/get/ecom-items`, data
    );
  }

  getCategoriesList(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/ecommerce/ecom-categories`, data
    );
  }

  getCollectionList(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/ecommerce/ecom-collection`, data
    );
  }

  getitemsListByCategories(data: any) {
    if (!data.request)
      data.request = 'BUSINESS';

    return this.http.put(
      environment.baseUrl + `ecommerce/product/item/search`, data
    );
  }

  // ✅ New function to check if product already exists
  checkProductExists(productName: string) {
    const payload = {
      request: 'BUSINESS',
      name: productName   // 🔹 adjust key if backend expects "itemName" instead of "name"
    };

    return this.http.put(
      environment.baseUrl + `ecommerce/product/item/search`, payload
    );
  }

  getProductListByCategorie(categoryId: any) {
    return this.http.get(
      environment.serverIp + `ecommerce/categories?categoryId=${categoryId}`
    );
  }

  getProductListByCollection(collectionId: any) {
    return this.http.get(
      environment.serverIp + `ecommerce/categories?collectionId=${collectionId}`
    );
  }

  addNewProduct(data: any) {
    return this.http.post(
      environment.serverIp + `ecommerce/items`, data
    );
  }

  addNewCategory(data: any) {
    return this.http.post(
      environment.serverIp + `ecommerce/category`, data
    );
  }

  addNewCollection(data: any) {
    return this.http.post(
      environment.serverIp + `ecommerce/collection`, data
    );
  }

  deleteProduct(productId: string) {
    return this.http.delete(
      environment.baseUrl + `admin/ecommerce/delete/item?itemId=${productId}`
    );
  }

  deleteCategory(categoryId: string) {
    return this.http.delete(
      environment.baseUrl + `admin/ecommerce/delete/category?categoryId=${categoryId}`
    );
  }

  deleteCollection(collectionId: string) {
    return this.http.delete(
      environment.baseUrl + `admin/ecommerce/delete/collection?collectionId=${collectionId}`
    );
  }

  getCategoryBySubIndustryId(subId: string) {
    return this.http.get(
      environment.baseUrl + `admin/ecommerce/${subId}/category/list`
    );
  }

  getCollectionBySubIndustryId(subId: any) {
    return this.http.get(
      environment.baseUrl + `admin/ecommerce/${subId}/collection/list`
    );
  }

  getAllTaxes() {
    return this.http.get(
      environment.baseUrl + `admin/tax/masters/?taxType=GST`
    );
  }
}
